function Availability() {
	return (
		<div className="cancellationPolicyContainer cancellationPolicyContainerAlt">
			<p className="cancellationPolicyTitle tag visionCardTag">Availability</p>
			<div className="hoursContainer">
				<p className="cancellationPolicyText">
					<b>Friday</b> <br /> 5:30 - 9:30pm
				</p>
				<p className="cancellationPolicyText">
					<b>Saturday</b>
					<br />
					10am-6pm
				</p>
				<p className="cancellationPolicyText">
					<b>Sunday</b>
					<br />
					10am-3pm
				</p>
			</div>
		</div>
	);
}

export default Availability;
